import { Ref, forwardRef } from 'react'

import { Box, useClassNames } from '@factorialco/deprecated-design-system'
import { TimePlanningBalance, TimePlanningBalancesByPeriod } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import WrapperCell from 'modules/shift_management/components/ShiftManagement/Content/Body/DataTable/Cells/WrapperCell'
import * as stylesRefs from 'modules/shift_management/components/ShiftManagement/Content/Body/DataTable/index.vanilla.css'
import { gridTemplateColumns } from 'modules/shift_management/components/ShiftManagement/Content/Body/DataTable/utils/buildColumns'
import type { ColumnsType } from 'modules/shift_management/components/ShiftManagement/Content/Body/DataTable/utils/buildColumns'
import { useSchedule } from 'modules/shift_management/hooks/useSchedule'
import type { ShiftsRow } from 'modules/shift_management/lib/types'
import type DefaultShifts from 'modules/shift_management/store/internal/collections/DefaultShifts'

import { FirstCell } from './FirstCell'
import ShiftsRowsPerView from './ShiftsRowsPerView'

interface RowProps {
  shiftsRow: ShiftsRow
  columns: ColumnsType
  balances?: TimePlanningBalance
  periodBalances?: TimePlanningBalancesByPeriod[]
  visibleDefaultShifts: DefaultShifts
}

const Row = (
  { shiftsRow, columns, balances, periodBalances, visibleDefaultShifts }: RowProps,
  ref: Ref<HTMLDivElement>
) => {
  const [{ view }] = useSchedule()
  const cx = useClassNames(stylesRefs)

  return (
    <Box
      ref={ref}
      className={cx('grid')}
      style={{
        ...gridTemplateColumns('s240', view, 'content', 0),
      }}
    >
      <WrapperCell sticky minWidth="s240">
        <FirstCell
          view={view}
          shiftsRow={shiftsRow}
          balances={balances}
          periodBalances={periodBalances}
        />
      </WrapperCell>
      <ShiftsRowsPerView
        shiftsRow={shiftsRow}
        columns={columns}
        visibleDefaultShifts={visibleDefaultShifts}
      />
    </Box>
  )
}

export default observer(forwardRef(Row))
